export default __webpack_public_path__ + "static/media/temperature-empty.c7dccbc0.svg";